import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
    Grid,
    Card,
    InputLabel,
    Button,
    Typography,
    Box,
    TextField,
} from '@mui/material';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import dummyLogo from '../../../assets/images/dummyImage.png'; // Your dummy logo path
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import service from '../../api/services';
import { useNavigate, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import SoftButton from 'components/SoftButton';

const validationSchema = Yup.object({
    categoryName: Yup.string().required('Category name is required'),
    logo: Yup.mixed().required('Logo is required'),
    tile: Yup.mixed().required('Tile is required'),
    image: Yup.mixed().required('Image is required'),
    sequence: Yup.number().required('Sequence number is required'),
});

const CreateCategoryForm = () => {
    const params = useParams()
    const navigate = useNavigate()
    const [previews, setPreviews] = useState({
        logo: dummyLogo,
        tile: dummyLogo,
        image: dummyLogo,
    });

    const formik = useFormik({
        initialValues: {
            categoryName: '',
            logo: null,
            tile: null,
            image: null,
            sequence: '',
        },
        validationSchema,
        onSubmit: async (values) => {
            try {
                const formData = new FormData();
                formData.append('name', values.categoryName);
                 formData.append('sequenceNumber', values.sequence);

                // Only append logo if user selected a file
                if (values.logo) {
                    formData.append('logo', values.logo);
                }
                if (values.tile) {
                    formData.append('tile', values.tile);
                }
                if (values.tile) {
                    formData.append('bannerImage', values.tile);
                }

                const response = params?.id
                    ? await service.categories.edit(params?.id, formData)
                    : await service.categories.add(formData);

                if (response.status === 200 || response.status === 201) {
                    navigate(-1);
                    toast.success(response?.data?.message);
                } else {
                    toast.error(response?.data?.message);
                }
            } catch (error) {
                toast.error(error?.response?.data?.message);
                console.error('Submission error:', error);
            }
        },
    });

    const handleFileChange = (event, field) => {
        const file = event.currentTarget.files[0];
        formik.setFieldValue(field, file);
        if (file) {
            setPreviews((prev) => ({
                ...prev,
                [field]: URL.createObjectURL(file),
            }));
        }
    };
    const getDetailById = async () => {
        try {
            const res = await service.categories.getDetailById(params.id);
            const data = res?.data?.data;


            formik.setValues({
                categoryName: data?.name || '',
                logo: data?.logo || null,
                tile: data?.tile || '',
                image: data?.bannerImage || '',
                sequence: data?.sequenceNumber || '',
            });

            setPreviews({
                logo: data?.logo || dummyLogo,
                tile: data?.tile || dummyLogo,
                image: data?.bannerImage || dummyLogo,
            })
        } catch (error) {
            console.error('Error fetching category details:', error);
        }
    };


    useEffect(() => {

        if (params?.id) {
            console.log('asdfasdf', params?.id)
            getDetailById()
        }
    }, [])
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Box mt={3}>
                <Card className="glassmorphism-card"
                    sx={{
                        // width: 470,
                         minHeight:'500px',
                        display: "flex",
                        flexDirection: "column",
                        // justifyContent: "center",
                        // alignItems: "center",
                        padding: 2,
                        boxShadow: 2,

                    }}>
                    <Typography variant="h6" fontWeight="bold" gutterBottom>
                        Create category
                    </Typography>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <SoftTypography variant="caption" fontWeight="bold" required>Enter category<span style={{ color: 'red' }}>*</span></SoftTypography>
                                <SoftInput
                                    fullWidth
                                    placeholder="Enter category name"
                                    name="categoryName"
                                    value={formik.values.categoryName}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.categoryName && Boolean(formik.errors.categoryName)}
                                    helperText={formik.touched.categoryName && formik.errors.categoryName}
                                />
                                {formik.touched.categoryName && formik.errors.categoryName && (
                                    <SoftTypography variant="caption" color="error"  sx={{color:'red'}}>
                                        {formik.errors.categoryName}
                                    </SoftTypography>
                                )}
                            </Grid>

                            {['logo', 'tile', 'image'].map((field) => (
                                <Grid item xs={4} key={field}>
                                    <SoftTypography variant="caption" fontWeight="bold" required>Upload {field}<span style={{ color: 'red' }}>*</span></SoftTypography>
                                    <Box component="img" src={previews[field]} sx={{ height: 80, mb: 3 }} />
                                    <div>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            name={field}
                                            onChange={(e) => handleFileChange(e, field)}
                                        />
                                        <div>

                                            {formik.touched[field] && formik.errors[field] && (
                                                <SoftTypography variant="caption" color="error"  sx={{color:'red'}}>
                                                    {formik.errors[field]}
                                                </SoftTypography>
                                            )}
                                        </div>
                                    </div>
                                </Grid>
                            ))}

                            <Grid item xs={12}>
                                <SoftTypography variant="caption" fontWeight="bold" required>Enter Sequence Number<span style={{ color: 'red' }}>*</span></SoftTypography>
                                <SoftInput
                                    fullWidth
                                    placeholder="Enter sequence number"
                                    name="sequence"
                                    type="number"
                                    value={formik.values.sequence}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.sequence && Boolean(formik.errors.sequence)}
                                    helperText={formik.touched.sequence && formik.errors.sequence}
                                />
                                {formik.touched.sequence && formik.errors.sequence && (
                                    <SoftTypography variant="caption" color="error" sx={{color:'red'}}>
                                        {formik.errors.sequence}
                                    </SoftTypography>
                                )}
                            </Grid>

                            <Grid item xs={12} display="flex" gap={2}>
                                <SoftButton type="submit" variant="gradient" color="info">
                                    Submit
                                </SoftButton>
                                <SoftButton
                                    
                                    variant="outlined"
                                    color="info"
                                    onClick={() => navigate(-1)}
                                >
                                    Cancel
                                </SoftButton>
                                
                            </Grid>
                        </Grid>
                    </form>
                </Card>
            </Box>
        </DashboardLayout>
    );
};

export default CreateCategoryForm;
